import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface getBDAWarehouseIntegrationByIdInterface {
  id?: string
}

/**
 * Fetch the BDA (B-Connect) integration for a warehouse.
 *
 * NOTE the route shape differs from the ICS/Paperless hooks: it is
 * `/Warehouse/{id}/BDAIntegration`, not `/Warehouse/{id}/BDA`.
 *
 * The response deliberately omits ClientSecret — it returns `hasClientSecret`
 * only — so the edit form cannot pre-fill the secret.
 */
export const useGetBDAWarehouseIntegrationById = () => {
  const mutate = useMutation(
    ({ id }: getBDAWarehouseIntegrationByIdInterface) => {
      return get(`/Warehouse/${id}/BDAIntegration`)
    },
  )

  return mutate
}

export default useGetBDAWarehouseIntegrationById
